/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectType } from './subjectType.model';
import { HouseNumberType } from './houseNumberType.model';


export interface OwnershipSubjectDto { 
    castObce?: string;
    cisloDomovni?: number;
    cisloOrientacni?: string;
    cpCe?: HouseNumberType;
    ico?: number;
    id?: number;
    jmeno?: string;
    lpisId?: number;
    mestskaCast?: string;
    nazev?: string;
    obec?: string;
    okres?: string;
    opsubType?: SubjectType;
    prijmeni?: string;
    psc?: number;
    rodneCislo?: string;
    stat?: string;
    subjectId?: number;
    subjectPartner1?: OwnershipSubjectDto;
    subjectPartner2?: OwnershipSubjectDto;
    titulPredJmenem?: string;
    titulZaJmenem?: string;
    ulice?: string;
}
export namespace OwnershipSubjectDto {
}


